
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Fetch } from '../services/fetch/fetch-service';
import { doFetch } from '../services/fetch/fetch.actions';
import { fetchProfile } from '../services/politician/profile-service';

class VerifyWrapper extends Component {
  componentDidMount() {
    const { profile: { fetched, fetching }, dispatch } = this.props;
    Fetch('/idp-auth/self-verify');
    if (!fetched && !fetching) {
      dispatch(doFetch('PROFILE', fetchProfile().then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })));
    }
  }

  render() {
    const { Page, ...otherProps } = this.props;
    return (
      <Page {...otherProps} />
    );
  }
}

VerifyWrapper.propTypes = {
  Page: PropTypes.any.isRequired,
  profile: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};


const mapStateToProps = ({ profile }) => ({ profile });
export default connect(mapStateToProps)(VerifyWrapper);
